const HeatmapURLs = (name,items) => {
    switch (name) {
      case 'GET_HEATMAP_TABLE_DATA':  {
        return `/api/usp/HeatMapSummary?${items.data}`;
      }
      case 'GET_HEATMAP_DROPDOWN_DATA':  {
        return `/api/usp/HeatMapGetMasters?RoleID=${items.roleId}`;
      }
      case 'UPDATE_HEATMAP_FORM_DATA':  {
        return `/api/usp/HeatMapForm`;
      }
      case 'GET_HEATMAP_FORM_TABLE_DATA':  {
        return `/api/usp/HeatMapGetFormData?CustomerID=${items.customerId}&ToolID=${items.toolId}&ServicedeskID=${items.servicedeskId}`;
      }
      case 'GET_VISHING_DROPDOWN_DATA':  {
        return `/api/usp/AQuAAGetVishingMasters?RoleID=${items.roleId}`;
      }
      case 'UPDATE_VISHING_FORM_DATA':  {
        return `/api/usp/AquAAVishing`;
      }
      case 'GET_VISHING_FORM_TABLE_DATA':  {
        return `/api/usp/AQuAAGetVishingEntries`;
      }
      case 'GET_VISHING_VALIDATE_TICKET_NO':  {
        return `/api/usp/AQUAAVishingCheckTicketNumber?TicketNumber=${items.ticketNo}`;
      }
       default: {}
    }
}
export default HeatmapURLs;